import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 451 487" {...props}>
      <title id="Vocals">{props.title || 'Vocals'}</title>
      <g>
        <g>
          <path d="M264.4 75.4c47.5 10.9 85.8 47.3 98.6 96.5 12.8 49.2-3.6 100.2-38.3 133 10.9-32.8 10.9-76.5-1.8-122.1-9.2-45.5-32.9-83.7-58.5-107.4zm34.7-74.7c67.6 21.9 124.2 76.5 144.2 149.3 20.1 74.7-1.8 149.4-49.2 202.2 23.7-52.8 29.2-122 10.9-191.2-20.1-69.2-60.2-127.5-105.9-160.3z" />
          <path d="M217.7 358.1c29.9-16.3 54.4-58.4 54.4-100.5 0-67.8 0-122.1-81.6-122.1-81.7 0-81.7 54.3-81.7 122.1 0 42.1 24.5 84.2 54.4 100.5v21.7c-92.5 8.1-163.2 52.9-163.2 107.2h380.9c0-54.3-70.7-100.4-163.2-107.2v-21.7z" />
        </g>
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/vocals.js